import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="hero-section-new">
      <div className="hero-content-new">
        <div className="logo-container-new">
          <img src="/logo.png" alt="The Nick & JJ Show" className="hero-logo" />
        </div>
        <h1 className="hero-title-new">
          BE BOLD.<br />BE HEARD.<br />FLEXX YOU.
        </h1>
        <p className="hero-subtitle-new">
          Creating a safe space for youth voices — where laughter, learning, and leadership meet.
        </p>
        <div className="hero-buttons-new">
          <Button 
            className="btn-youtube"
            onClick={() => window.open('https://youtube.com/@nickandjjshow?si=m9H0Fw5UYWS4sEgE', '_blank')}
          >
            <svg className="icon" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
            WATCH ON YOUTUBE
          </Button>
          <Button 
            className="btn-join"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
            </svg>
            JOIN THE AUDIENCE
          </Button>
        </div>
      </div>
      <div className="hero-wave"></div>
    </section>
  );
};

export default Hero;